//import { createWidget } from '@typeform/embed'
//import '@typeform/embed/build/css/widget.css'
import "jquery-ui/ui/data.js";
import "jquery-ui/ui/widget.js";

$(document).ready(function () {
    var element = $("[data-widget=typeform]");

    var arr = $("[data-widget=typeform]").map(function (i, ele) {
        var options = {};

        var event = jQuery.Event("InitWidget");
        $(ele).trigger(event);

        if (!event.isDefaultPrevented()) {
            options["formid"] = $(ele).attr("data-widget-formid");
            $(ele)[element.data("widget")](options);
        }
    }).get();

    $.widget("custom.typeform", {
        options: {
            formid: '',
            adduserinfo: false
        },
        _init: function () {
            var $widget = this,
                $element = $widget.element;
            $element.click(function () {
                window.fsForms.createForm($widget.options.formid, $widget.options.adduserinfo);
            });
            /*       Window.fstypeform({ id:'asdasd' type:'asdasd' form:'asdasd'})*/
        },
    });

    /*
     y7REg4qq
     I4Nq9v9A
     */

});
